import styled from 'foundations-theming/utils';
export const VisibilityView = styled.div.withConfig({
  displayName: "VisibilityView"
})(({
  visible = true
}) => {
  return {
    visibility: visible ? 'visible' : 'hidden',
    width: '100%'
  };
});